import { ArrowRight } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { ResourceBadge } from "@/components/resource-badge";

interface ResourceCardProps {
  cta?: string;
  description?: string;
  href: string;
  img: string;
  meta?: string | null;
  title: string;
  type: string;
}

export function ResourceCard({
  type,
  title,
  description,
  href,
  img,
  cta = "Read more",
  meta,
}: ResourceCardProps) {
  return (
    <Link
      className="group flex h-full flex-col overflow-hidden rounded-2xl border bg-card transition-shadow hover:shadow-md"
      href={href}
    >
      {/* Image */}
      <div className="relative aspect-[3/2] overflow-hidden">
        <Image
          alt=""
          aria-hidden="true"
          className="object-cover"
          fill
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
          src={img}
        />
      </div>

      {/* Content */}
      <div className="flex flex-1 flex-col p-6">
        {/* Badge + meta */}
        <div className="mb-2 flex items-center gap-3">
          <ResourceBadge type={type} />
          {meta && (
            <span className="text-muted-foreground text-sm">{meta}</span>
          )}
        </div>

        {/* Title */}
        <h3 className="mb-2 font-bold text-2xl leading-snug">{title}</h3>

        {/* Description */}
        {description && (
          <p className="flex-1 text-base text-muted-foreground leading-6">
            {description}
          </p>
        )}

        {/* CTA */}
        <div className="mt-6 inline-flex shrink-0 select-none items-center gap-1.5 self-start font-medium text-sm transition-[gap] duration-200 ease-out group-hover:gap-4 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0">
          {cta}
          <ArrowRight />
        </div>
      </div>
    </Link>
  );
}
